window_adjust = function(){
	
	var window_w = $(window).width();
	var breakpoint = 734;
	if(window_w < breakpoint){
		$('body').addClass('mobile').removeClass('pc');
	} else {
		$('body').removeClass('mobile').addClass('pc');
	}
	
}

menu_close = function(){
	
	$('body').removeClass('bended').addClass('expanded');
	
	$('#switch_middle').animate({
		'opacity': 0
	},100);
	
	$('#menu').fadeIn(300);
	
}

menu_show = function(){
	
	$('body').removeClass('expanded').addClass('bended');
	
	$('#switch_middle').animate({
		'opacity': 1
	},500);
	
	$('#menu').fadeOut(600);
	
}

menu_init = function(){
	
	$('body').removeClass('expanded').addClass('bended');
	
	$('#switch_middle').animate({
		'opacity': 1
	},500);
	
	$('#menu').fadeOut(300);
	
}

menu_reset = function(){
	
	$('body').removeClass('expanded').addClass('bended');
	
	$('#switch_middle').css({
		'opacity': 1
	});
	
	$('#menu').hide();
	
}


$(window).on('load',function(){
	
	window_adjust();
		
});

$(window).on('resize',function(){
	
	window_adjust();
		
});

$(window).on('scroll',function(){
	
	var window_h = $(window).height();
	var hero_h = $('#things_hero').height() * 2;
	
	if($(this).scrollTop() >= window_h){
		$('#back').fadeIn(500);
	} else {
		$('#back').fadeOut(200);
	};
	
});

$(function(){

	
	var isTouch = (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch);
	var click = (isTouch) ? 'touchend' : 'click';

	var inner = $('.post').width();
	
	$('.post img').each(function() {

		var img = new Image();
		img.src = $(this).attr('src');
		var width = img.width;
		if (width >= inner) {
			$(this).addClass('fit').animate({
				'opacity': '1'
			}, 400);
		} else {
			$(this).addClass('nonfit').animate({
				'opacity': '1'
			}, 400);
		}

	});
	
	var hash = location.hash;
	var speed = 600;
	var offset = 30;
	
	
	//Scroll to top
	$('#back').on(click, function() {
		$('body,html').animate({
			scrollTop: 0
		},speed,'easeOutExpo');
		// menu_init();
		return false;
	});
	
	$('a.anchor').on(click, function() {
		var href= $(this).attr('href');
		var target = $(href == '#' || href == '' ? 'html' : href);
		var position = target.offset().top - offset;
		$('body,html').animate({
			scrollTop: position
		},speed,'easeOutExpo');
		menu_init();
		return false;
	});
	
	//hash
	if(hash){
		if($(hash).length){
			var target = $(hash);
		} else if($(hash).length == 0 && $('#waist form').length){
			var target = $('#waist form');
		} else {
			var target = $('#waist');
		}
		var position = target.offset().top - offset;
		$('body,html').animate({
			scrollTop: position
		},speed,'easeOutExpo');
		// menu_init();
	}
	
	$('#menu_switch').on(click,function(){
		
		if($('body').hasClass('bended')){
			
			menu_close();
			
		} else {
			
			menu_show();
			
		}
		
	});
	
	$('.fading').each(function(){
		$(this).on('inview', function(event, isInView) {
			if(isInView){
				$(this).delay(0).animate({
					'opacity': 1,
					'padding-top': 0
				},1000);
			} else {
				//$(this).animate({
				//	'opacity': 0
				//},200);
			}
		});
	});

	//Enterキーでの送信を禁止する
	$('input').keydown(function(e) {
		if ((e.which && e.which === 13) || (e.keyCode && e.keyCode === 13)) {
			return false;
		} else {
			return true;
		}
	});

	$('.menu_parent').on('click', function(){

		$(this).toggleClass('active');
		
		$(this).find('.menu_children').fadeToggle('300');

	});
	
});